import React from 'react';
import Link from 'next/link';
import { Container, Row, Col } from 'reactstrap';
import data from '../../data/overtochten.json';
import Image from "../../components/CustomImage";
import { getImageUrl } from "../../services/image";
import Head from "next/head";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Index = function Index() {
  var groupByN = function groupByN(n, data) {
    var result = [];

    for (var i = 0; i < data.length; i += n) {
      result.push(data.slice(i, i + n));
    }

    return result;
  };

  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "Boot en Eurotunnel overtochten Engeland Ierland Schotland - Cottage Centre Vakantiehuizen en Campers"
      }), /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: "Boot of Eurotunnel overtochten via Cottage Centre"
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: "hero py-6 py-lg-7 text-white dark-overlay",
      children: [/*#__PURE__*/_jsx(Image, {
        src: getImageUrl('dfds_promo_image.jpg'),
        alt: "",
        className: "bg-image",
        loading: "eager",
        layout: "fill",
        priority: true
      }), /*#__PURE__*/_jsx(Container, {
        className: "overlay-content",
        children: /*#__PURE__*/_jsx("h1", {
          className: "hero-heading",
          children: data.title && data.title
        })
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: "py-3",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs("blockquote", {
          className: "blockquote blockquote-primary bg-gray-100 p-5",
          children: [/*#__PURE__*/_jsx("h2", {
            children: "Overtochten"
          }), /*#__PURE__*/_jsx("p", {
            children: "Er zijn diverse mogelijkheden voor overtochten naar Engeland, Schotland en Ierland. Cottage Centre kan door goede samenwerkingen voor de diverse overtochten adviezen geven over de juiste verbinding tegen de scherpste prijs. Door onze samenwerkingen betaalt u bij ons nooit meer dan direct bij de ferry-maatschappij."
          }), /*#__PURE__*/_jsx("h3", {
            className: "h5",
            children: "Hoe te boeken"
          }), /*#__PURE__*/_jsx("p", {
            children: "Bij het boeken van uw cottage kunt u in het winkelwagentje aangeven ook informatie te willen ontvangen betreffende de best passende overtocht en prijs. U ontvangt van ons zo snel mogelijk de offerte zodat u de overtocht ook direct kunt vastleggen."
          }), /*#__PURE__*/_jsx("ul", {
            children: data.questionGroups && data.questionGroups.map(function (group, index) {
              return /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/overtocht/#".concat(group.hash),
                  scroll: false,
                  children: group.title
                })
              }, index);
            })
          })]
        }), data.questionGroups && data.questionGroups.map(function (group) {
          var groupedQuestions = group.questions && groupByN(group.groupSize, group.questions);
          return /*#__PURE__*/_jsxs("div", {
            className: "py-4",
            children: [/*#__PURE__*/_jsx("a", {
              className: "anchor",
              id: "".concat(group.hash)
            }), /*#__PURE__*/_jsx("h2", {
              className: "mb-3 text-primary",
              children: group.title
            }), /*#__PURE__*/_jsx("div", {
              dangerouslySetInnerHTML: {
                __html: group.intro
              }
            }), /*#__PURE__*/_jsx(Row, {
              children: groupedQuestions.map(function (questions) {
                return /*#__PURE__*/_jsx(Col, {
                  md: "6",
                  children: questions.map(function (question) {
                    return /*#__PURE__*/_jsxs(React.Fragment, {
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: question.title
                      }), /*#__PURE__*/_jsx("p", {
                        className: "text-muted mb-4",
                        children: question.content
                      })]
                    }, question.title);
                  })
                }, questions[0].title);
              })
            })]
          }, group.title);
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default Index;